import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";

// Type definitions
interface ChangeViewProps {
  center: [number, number];
}

interface MiniMapProps {
  latitude: number | string | null | undefined;
  longitude: number | string | null | undefined;
  height?: string;
  zoom?: number;
  className?: string;
}

// Van icon configuration
const vanIcon = new L.Icon({
  iconUrl: '/van.ico',
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -30],
  shadowUrl: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGVsbGlwc2UgY3g9IjIwIiBjeT0iMzUiIHJ4PSIxNSIgcnk9IjQiIGZpbGw9InJnYmEoMCwwLDAsMAuMykiLz4KPHN2Zz4K',
  shadowSize: [40, 40],
  shadowAnchor: [20, 35]
});

// Component to change map view when coordinates change
const ChangeView: React.FC<ChangeViewProps> = ({ center }) => {
  const map = useMap();
  
  useEffect(() => {
    if (map && center && center[0] && center[1]) {
      map.setView(center, map.getZoom());
    }
  }, [center, map]);
  
  return null;
};

// Main MiniMap component
const MiniMap: React.FC<MiniMapProps> = ({
  latitude,
  longitude,
  height = '150px',
  zoom = 13,
  className = ''
}) => {
  // Convert and validate coordinates
  const lat = typeof latitude === 'string' ? parseFloat(latitude) : Number(latitude);
  const lng = typeof longitude === 'string' ? parseFloat(longitude) : Number(longitude);
  
  console.log("MiniMap coords:", lat, lng);
  
  // Validate coordinates
  if (!latitude || !longitude || isNaN(lat) || isNaN(lng)) {
    return (
      <div
        className={`flex items-center justify-center bg-gray-100 text-gray-500 text-sm rounded-lg border-2 border-dashed border-gray-300 ${className}`}
        style={{ height }}
      >
        <div className="text-center">
          <div className="mb-1">📍</div>
          <div>Locație indisponibilă</div>
        </div>
      </div>
    );
  }
  
  // Additional validation for reasonable coordinate ranges
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
    return (
      <div
        className={`flex items-center justify-center bg-red-50 text-red-500 text-sm rounded-lg border-2 border-dashed border-red-300 ${className}`}
        style={{ height }}
      >
        <div className="text-center">
          <div className="mb-1">⚠️</div>
          <div>Coordonate invalide</div>
        </div>
      </div>
    );
  }
  
  const center: [number, number] = [lat, lng];
  
  return (
    <div className={`rounded-lg overflow-hidden shadow-sm border border-gray-200 relative ${className}`}>
      <MapContainer
  center={center}
  zoom={zoom}
  scrollWheelZoom={true}
  dragging={true}
  doubleClickZoom={true}
  zoomControl={true}
  attributionControl={false}
  style={{
    height,
    width: '100%'
  }}
>
  <TileLayer
    attribution='&copy; OpenStreetMap contributors'
    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    maxZoom={18}
  />
  <ChangeView center={center} />
  <Marker position={center} icon={vanIcon} />
</MapContainer>

      
      {/* Optional coordinates display */}
      <div className="absolute bottom-1 right-1 bg-black/60 text-white text-xs px-2 py-1 rounded opacity-75">
        {lat.toFixed(4)}, {lng.toFixed(4)}
      </div>
    </div>
  );
};

export default MiniMap;